const globalMessagesTypes = ['ERROR', 'WARNING', 'SUCCESS', 'INFO'];

const getGlobal = state => (state && state.global) || {};
const getSite = state => getGlobal(state).site;
const getBaseStore = state => getGlobal(state).baseStore;
const getOccBaseUri = state => getGlobal(state).occBaseUri;
const getWishlistMode = state => getGlobal(state).wishlistMode;
const multipleWishlistsEnabled = state => getWishlistMode(state) === 'multiple';
const getAvailableLanguages = state => getGlobal(state).availableLanguages || [];
const getCountry = state => getGlobal(state).country;
const getLanguage = state => getGlobal(state).language;
const isSubmitting = state => getGlobal(state).submitting;
const getEnterClicked = state => getGlobal(state).enterClicked;
const getLastTimePageLoad = state => getGlobal(state).lastTimePageLoad;
const getMessages = state => getGlobal(state).messages;
const getPrevPageData = state => getGlobal(state).prevPageData;
const getOriginAction = state => getGlobal(state).originAction;

const getPreferredCountry = state => getGlobal(state).preferredCountry;
const getDeliveryCountry = state => getGlobal(state).deliveryCountry;
const countryDialogClosed = state => getGlobal(state).countryDialogClosed;
const languageDialogClosed = state => getGlobal(state).languageDialogClosed;
const getPreferredLanguage = state =>
    getGlobal(state).preferredLanguage ||
    (getAvailableLanguages(state).length === 1 && getAvailableLanguages(state)[0]) ||
    null;
const getImagePlaceholderPath = state => getGlobal(state).imagePlaceholderPath;

const isTurbolinksEnabled = state => getGlobal(state).useTurbolinks;
const getCurrencyCode = state => getGlobal(state).currencyCode;
const getConfigurations = state => getGlobal(state).configurations;

const filterMessage = (message, filter) => {
    return message.type.toUpperCase() === filter.toUpperCase();
};

const getGlobalMessages = state => {
    const globalMessages = [];
    globalMessagesTypes.forEach(type => {
        globalMessages.push(
            ...state.global.globalMessages.filter(message => filterMessage(message, type)),
        );
    });

    return globalMessages;
};
const getBrCatalogName = state => getGlobal(state).brCatalogName;
const getGlobalPageInfo = state => getGlobal(state).globalPageInfo;
const getThresholdConfig = state => getGlobal(state).thresholdConfig || {};
const getThresholdFeatureFlag = state => getThresholdConfig(state).isThresholdPromotionEnabled;
const getThresholdTextLabel = state => getThresholdConfig(state).thresholdPriceLabel;

export default {
    getGlobalMessages,
    getCountry,
    getLanguage,
    getPreferredCountry,
    getPreferredLanguage,
    getAvailableLanguages,
    getSite,
    getBaseStore,
    getOccBaseUri,
    getWishlistMode,
    multipleWishlistsEnabled,
    isTurbolinksEnabled,
    languageDialogClosed,
    countryDialogClosed,
    getImagePlaceholderPath,
    isSubmitting,
    getEnterClicked,
    getLastTimePageLoad,
    getMessages,
    getPrevPageData,
    getOriginAction,
    getCurrencyCode,
    getDeliveryCountry,
    getConfigurations,
    getBrCatalogName,
    getGlobalPageInfo,
    getThresholdConfig,
    getThresholdFeatureFlag,
    getThresholdTextLabel,
};
